import { getPageInfo } from '../EMR_Integration/react_webInjector.ts';

function hostOf(url) {
  try {
    return new URL(url).hostname;
  } catch (_) {
    return null;
  }
}

/**
 * Keep the note Learn was clicked on as a complete example for Re-Learn My
 * Style, whether or not Learn finds anything to change. The backend skips it
 * when Get All Notes already captures this EMR for the user. Never throws:
 * Learn must not depend on this.
 */
export async function saveLearnExample(
  apiClient,
  conversationId,
  configId,
  questions,
  pageInfoOverride = null,
) {
  try {
    if (!configId || configId === -1 || !Object.keys(questions || {}).length) {
      return;
    }
    const pageInfo = pageInfoOverride || await getPageInfo();
    const emr = hostOf(pageInfo?.URL);
    if (!emr) return;
    await apiClient.saveLearnExample({
      conversationId: Number(conversationId),
      configId: Number(configId),
      learnedAt: Date.now(),
      questions,
      emr,
      pageInfo,
    });
  } catch (error) {
    console.warn('Could not save the Learn example', error);
  }
}
